<div class="container">
    <div class="main-header__inner">
        <nav class="main-header__nav main-menu">

            <ul class="main-menu__list">
                <li>
                    <a [routerLink]="'/'">{{ "HOME" | translate }}</a>
                </li>
                <li class="dropdown">
                    <a href="#">{{ "ARP" | translate }}</a>
                    <ul>
                        <li><a href="/#about"  >{{ "Présentation de l'Institution" | translate }}</a></li>
                        <li><a  href="/#missions"   >{{ "Missions" | translate }}</a></li>
                        <li><a [routerLink]="['/page', 'conseil-arp']">{{ "Conseil de l'ARP" | translate }}</a></li>
                        <li style="display: none;"><a [routerLink]="['/autorite/bureau']">{{ 'autorite_menu_bureau' | translate }}</a></li>
                        <li><a [routerLink]="['/autorite/comites']">{{ 'autorite_menu_comites' | translate }}</a></li>
                        <li><a [routerLink]="['/autorite/anciens-presidents']">{{ 'autorite_menu_anciens' | translate }}</a></li>
                    </ul>
                </li>
                <li class="dropdown">
                    <a [routerLink]="['/loi']">{{ 'loi_menu' | translate }}</a>
                    <ul>
                        <li>
                            <a [routerLink]="['/loi']" [queryParams]="{category:'loi'}">
                                {{ 'loi_menu_lois_decrets' | translate }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/loi']" [queryParams]="{category:'arrete'}">
                                {{ 'loi_menu_arretes' | translate }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/loi']" [queryParams]="{category:'circulaire'}">
                                {{ 'loi_menu_decisions' | translate }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/loi']">
                                {{ 'loi_menu_tout' | translate }}
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="dropdown">
                    <a href="#">{{ "Licences et Autorisations" | translate }}</a>
                    <ul>
                        <li><a [routerLink]="['/page', 'conditions-agrement-autorisation']">{{ "Conditions d'agrément et d'autorisation" | translate }}</a></li>
                        <li><a [routerLink]="['/annuaire']">{{ "annuaire_menu" | translate }}</a></li>
                    </ul>
                </li>
                <li class="dropdown">
                    <a href="#">{{ "Plaintes" | translate }}</a>
                    <ul>
                        <li><a [routerLink]="['/plainte']">{{ "plainte_menu_deposer" | translate }}</a></li>
                        <li><a [routerLink]="['/signalement']">{{ "signal_menu_deposer" | translate }}</a></li>
                        <li><a [routerLink]="['/suivi-plainte']">{{ "suivi_menu" | translate }}</a></li>
                        <li><a [routerLink]="['/page', 'plan_action']">{{ "Protection du consommateur" | translate }}</a></li>
                    </ul>
                </li>

                <li class="dropdown">
                    <a href="#">{{ 'pub_publications' | translate }}</a>
                    <ul>
                        <li>
                            <a [routerLink]="['/articles']" [queryParams]="{category_slug:'actualites'}">
                                {{ 'pub_actualites' | translate }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/articles']" [queryParams]="{category_slug:'evenements'}">
                                {{ 'pub_evenements' | translate }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/articles']" [queryParams]="{category_slug:'communiques'}">
                                {{ 'pub_communiques' | translate }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/articles']" [queryParams]="{category_slug:'ofres-et-marches'}">
                                {{ 'pub_ofres_marches' | translate }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/documents']" [queryParams]="{type:'document'}">
                                {{ 'pub_documents' | translate }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/documents']" [queryParams]="{type:'rapport_annuel'}">
                                {{ 'pub_rapports' | translate }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/galerie']">{{ 'galerie_menu' | translate }}</a>
                        </li>
                    </ul>
                </li>

                <li style="display: none;">
                    <a [routerLink]="['/paiement']" style="display:flex;align-items:center;gap:6px;">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                             style="width:14px;height:14px;flex-shrink:0;">
                            <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
                            <line x1="1" y1="10" x2="23" y2="10"/>
                        </svg>
                        Paiement
                    </a>
                </li>
                <li><a [routerLink]="['/contact']">{{ "CONTACT" | translate }}</a></li>

                <li class="dropdown">
                    <a href="#" [innerHTML]="currentLangLabel()"> </a>
                    <ul>
                        <li>
                            <a class="dropdown-item d-flex align-items-center {{ currentLang() == 'ar' ? 'fw-bold text-primary' : '' }}"
                                (click)="switchLanguage('ar')">
                                🇲🇷 <span class="ms-2">العربية</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item d-flex align-items-center {{currentLang() == 'fr' ? 'fw-bold text-primary' : '' }}"
                                (click)="switchLanguage('fr')">
                                🇫🇷 <span class="ms-2">Français</span>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item d-flex align-items-center {{ currentLang() == 'en' ? 'fw-bold text-primary' : '' }}"
                                (click)="switchLanguage('en')">
                                🇬🇧 <span class="ms-2">English</span>
                            </a>
                        </li>
                    </ul>
                </li>

            </ul>

        </nav><!-- /.main-header__nav -->
        <div class="main-header__right">
            <div class="mobile-nav__btn mobile-nav__toggler" (click)="mobileNav.toggle()">
                <span></span>
                <span></span>
                <span></span>
            </div><!-- /.mobile-nav__toggler -->
            <!-- ── Lien rapide vers la carte (section #map de la home) ── -->
            <a (click)="goToMap($event)"
               href="/#map"
               class="main-header__map"
               [title]="'Nous trouver' | translate"
               [attr.aria-label]="'Nous trouver' | translate">
                <i class="fa-solid fa-map-location-dot" aria-hidden="true"></i>
                <span class="sr-only">{{ 'sr_map' | translate }}</span>
            </a><!-- /.main-header__map -->

            <a href="#" class="search-toggler main-header__search" style="margin-left:0px !important;">
                <i class="icon-magnifying-glass" aria-hidden="true"></i>
                <span class="sr-only">{{ 'sr_search' | translate }}</span>
            </a><!-- /.search-toggler -->
        </div><!-- /.main-header__right -->
    </div><!-- /.main-header__inner -->
</div><!-- /.container-fluid -->
